<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">Sanções</h4>
      </v-alert>

      <v-row style="margin-left: 4px">
        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Processo"
            v-model="filtro.numeroProcesso"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Órgao"
            v-model="filtro.orgao"
          />
        </v-col>

        <v-col md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            type="date"
            label="Data Inicio"
            v-model="filtro.inicioSancao"
          />
        </v-col>
        <v-col md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            type="date"
            label="Data Fim"
            v-model="filtro.fimSancao"
          />
        </v-col>
      </v-row>
      <v-row style="margin-left: 4px; margin-top: -15px">
        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="CPF/CNPJ"
            v-model="filtro.cpfCnpj"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Sancionado"
            v-model="filtro.sancionado"
          />
        </v-col>

        <v-col cols="12" md="2" style="margin-top: 1.8%">
          <v-btn
            style
            color="primary"
            small
            depressed
            :loading="loadingBusca"
            :disabled="loadingBusca"
            @click="buscar()"
          >
            <v-icon small>fa-search</v-icon>
          </v-btn>

          <v-btn
            style="margin-left: 10px"
            small
            depressed
            color="primary"
            to="/sancoes/0"
            :disabled="!userHasPermission()"
          >
            <v-icon x-small style="margin-right: 5px">fa-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>

      <template>
        <v-data-table
          :headers="headers"
          :items="lista"
          :items-per-page="5"
          :loading="loadingBusca"
          class="elevation-1"
          no-results-text="A busca não trouxe resultados."
          no-data-text="A busca não trouxe resultados."
        >
          <template v-slot:loading>
            <LoadingSpinner text="Carregando sanções... aguarde." />
          </template>
          <template v-slot:item.inicioSancaoFormatada="{ item }">
            <span>
              {{
                item.inicioSancao
                  ? $moment(item.inicioSancao).format("DD/MM/YYYY")
                  : "Não Informado"
              }}
            </span>
          </template>

          <template v-slot:item.fimSancaoFormatada="{ item }">
            <span>
              {{
                item.fimSancao
                  ? $moment(item.fimSancao).format("DD/MM/YYYY")
                  : "Não Informado"
              }}
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item)"
                  :disabled="!userAdm()"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <v-dialog :retain-focus="false" v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="headline"
            >Confirma a exclusão do item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </app-layout>
</template>

<script>
import sancaoService from "@/service/SancaoService";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      deleteId: null,
      dialogDelete: false,
      loadingBusca: false,
      filtro: {
        numeroProcesso: null,
        orgao: null,
        cpfCnpj: null,
        sancionado: null,
        inicioSancao: null,
        fimSancao: null,
      },
      lista: [],
      headers: [
        { text: "Sancionado", value: "nome", sortable: false, width: "25%" },
        { text: "Processo", value: "numeroProcesso", sortable: false },
        { text: "Cpf / Cnpj", value: "cpfCnpj", sortable: false, width: "15%" },
        {
          text: "Data Inicio",
          value: "inicioSancaoFormatada",
          sortable: false,
        },
        { text: "Data Fim", value: "fimSancaoFormatada", sortable: false },
        { text: "Órgão", value: "orgao", sortable: false, width: "25%" },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
          align: "center",
          width: "8%",
        },
      ],
    };
  },
  methods: {
    editItem(item) {
      this.$router.push("/sancoes/" + item.sancaoId);
    },
    deleteItem(item) {
      this.deleteId = item.sancaoId;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      if (this.deleteId != null) {
        sancaoService.excluir(this.deleteId);
        this.deleteId = null;
        this.lista = [];
      }
      this.closeDelete();
    },
    buscar() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.loadingBusca = true;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      sancaoService
        .buscarSancaoFiltro(this.filtro)
        .then((result) => (this.lista = result || []))
        .catch(() => (this.lista = []))
        .finally(() => (this.loadingBusca = false));
    },

    closeDelete() {
      this.dialogDelete = false;
      this.deleteId = null;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
  },

  mounted() {
    sancaoService.findAll().then((res) => (this.lista = res));
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style></style>
